export default function errorExceptionSwitch(status, callback) {
  switch (status) {
    case 408:
      return { success: false, url: "/error" };
    case 403:
      return { success: false, url: "/login" };
    case 200:
      return { success: true, url: callback };
    default:
      return { success: false, url: "/error" };
  }
}
